import request from '@/utils/request'

const state = {
  treeData: [],
}
const mutations = {
  SET_TREEDATA: (state, data) => {
    state.treeData = data
  },
}
const actions = {
}

function saveData(type, data) {
  localStorage.setItem(type, JSON.stringify(data))
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
